import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import memoizeOne from '../../node_modules/memoize-one/dist/memoize-one.esm.js';
import FormContext$1 from './FormContext.js';
import { shouldFieldUpdate, fieldFormState } from './utils.js';

var ObjectDataProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ObjectDataProvider, _React$Component);

  var _super = _createSuper(ObjectDataProvider);

  function ObjectDataProvider() {
    var _this;

    _classCallCheck(this, ObjectDataProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "_prevChangeMetadata", undefined);

    _defineProperty(_assertThisInitialized(_this), "_prevChangeValue", undefined);

    _defineProperty(_assertThisInitialized(_this), "getObjectContext", memoizeOne(function (value, parentValue, formValue, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly, previousChange, previousFormChange) {
      return {
        value: value,
        parentValue: parentValue,
        formValue: formValue,
        onChange: onChange,
        errors: errors,
        onError: onError,
        showErrors: showErrors,
        allErrors: allErrors,
        animateErrors: animateErrors,
        disabled: disabled,
        readOnly: readOnly,
        previousChange: previousChange,
        previousFormChange: previousFormChange
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (field, data, applyChanges, metadata) {
      // keep track of the previous change state
      _this._prevChangeMetadata = metadata;
      _this._prevChangeValue = _this.props.value;

      _this.props.onChange(field, data, applyChanges, metadata);
    });

    return _this;
  }

  _createClass(ObjectDataProvider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return shouldFieldUpdate(this.props, nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          parentValue = _this$props.parentValue,
          formValue = _this$props.formValue,
          errors = _this$props.errors,
          onError = _this$props.onError,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          previousFormChange = _this$props.previousFormChange,
          children = _this$props.children; // determine if the object value corresponds with the metadata of the previous change

      var previousChange = this._prevChangeValue === this.state.prevValue ? this._prevChangeMetadata : undefined;
      var objectContext = this.getObjectContext(value, parentValue, formValue, this.onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly, previousChange, previousFormChange);
      return /*#__PURE__*/React.createElement(FormContext$1.Provider, {
        value: objectContext
      }, typeof children === "function" ? children(fieldFormState(objectContext)) : children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // keep track of the previous form value
      if (props.value !== state.value) {
        return {
          value: props.value,
          prevValue: state.value
        };
      }

      return null;
    }
  }]);

  return ObjectDataProvider;
}(React.Component);

_defineProperty(ObjectDataProvider, "propTypes", {
  value: _pt.any.isRequired,
  parentValue: _pt.any.isRequired,
  formValue: _pt.any.isRequired,
  onChange: _pt.any.isRequired,
  errors: _pt.any.isRequired,
  onError: _pt.any.isRequired,
  showErrors: _pt.bool.isRequired,
  allErrors: _pt.bool.isRequired,
  animateErrors: _pt.oneOfType([_pt.number, _pt.bool]).isRequired,
  disabled: _pt.bool.isRequired,
  readOnly: _pt.bool.isRequired,
  previousFormChange: _pt.any,
  propagateUpdates: _pt.any,
  children: _pt.oneOfType([_pt.node, _pt.func])
});

var getDefaultOptions = function getDefaultOptions() {
  return {
    defaultProps: {}
  };
};
/**
 * Higher-order function to create a form-connected object higher-order component
 * @param {Object} options Object options
 * @returns Object HOC
 */


var withFormObject = function withFormObject() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions();
  return function (FormObjectComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions();
    var objectDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits(ObjectWrapper, _React$Component2);

      var _super2 = _createSuper(ObjectWrapper);

      function ObjectWrapper() {
        var _this2;

        _classCallCheck(this, ObjectWrapper);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this2 = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this2), "_defaultChildValue", {});

        _defineProperty(_assertThisInitialized(_this2), "_defaultChildErrors", {});

        _defineProperty(_assertThisInitialized(_this2), "getChildValue", function () {
          var contextValue = _this2.context.value || {};
          return contextValue[_this2.props.field] || _this2._defaultChildValue;
        });

        _defineProperty(_assertThisInitialized(_this2), "onChildChange", function (field, data, applyChanges, metadata) {
          var objectField = _this2.props.field;
          var objectData = {
            field: field,
            data: data
          };

          var objectApplyChanges = function objectApplyChanges(prevValue) {
            var objectValue = applyChanges(prevValue[objectField] || {});

            if (prevValue && prevValue.hasOwnProperty(objectField) && prevValue[objectField] === objectValue) {
              return prevValue;
            }

            return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, objectField, objectValue));
          };

          if (_this2.context.onChange) {
            _this2.context.onChange(objectField, objectData, objectApplyChanges, metadata);
          }
        });

        _defineProperty(_assertThisInitialized(_this2), "getChildErrors", function () {
          var contentErrors = _this2.context.errors || {};
          return contentErrors[_this2.props.field] || _this2._defaultChildErrors;
        });

        _defineProperty(_assertThisInitialized(_this2), "onChildError", function (field, errors, applyErrors) {
          var objectField = _this2.props.field;
          var objectErrors = {
            field: field,
            errors: errors
          };

          var objectApplyErrors = function objectApplyErrors(prevErrors) {
            var oldErrors = prevErrors[objectField] || {};
            var newErrors = applyErrors(oldErrors);

            if (oldErrors === newErrors) {
              return prevErrors;
            }

            return _objectSpread2(_objectSpread2({}, prevErrors), {}, _defineProperty({}, objectField, newErrors));
          };

          if (_this2.context.onError) {
            _this2.context.onError(objectField, objectErrors, objectApplyErrors);
          }
        });

        return _this2;
      }

      _createClass(ObjectWrapper, [{
        key: "render",
        value: function render() {
          var _this$context$previou;

          var _ref = this.props,
              children = _ref.children,
              showErrors = _ref.showErrors,
              allErrors = _ref.allErrors,
              animateErrors = _ref.animateErrors,
              disabled = _ref.disabled,
              readOnly = _ref.readOnly,
              propagateUpdates = _ref.propagateUpdates;
          var contextValue = this.context.value || {};
          var contextProps = {
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly,
            previousFormChange: (_this$context$previou = this.context.previousFormChange) !== null && _this$context$previou !== void 0 ? _this$context$previou : this.context.previousChange
          };
          return /*#__PURE__*/React.createElement(FormObjectComponent, _extends({}, this.props, contextProps), /*#__PURE__*/React.createElement(ObjectDataProvider, _extends({}, contextProps, {
            value: this.getChildValue(),
            parentValue: contextValue,
            formValue: this.context.formValue || contextValue,
            onChange: this.onChildChange,
            errors: this.getChildErrors(),
            onError: this.onChildError,
            propagateUpdates: propagateUpdates
          }), children));
        }
      }]);

      return ObjectWrapper;
    }(React.Component), _defineProperty(_class, "propTypes", {}), _defineProperty(_class, "defaultProps", _objectSpread2({}, objectDefaultProps)), _defineProperty(_class, "contextType", FormContext$1), _defineProperty(_class, "displayName", "withFormObject(".concat(FormObjectComponent.displayName || FormObjectComponent.name, ")")), _temp;
  };
};

var withFormObject$1 = withFormObject;

export { withFormObject$1 as default };
